{
  "aboutProject": "Om prosjektet",
  "attachmentComment": "Kommentar til vedlegget",
  "attachmentName": "Namn på vedlegget",
  "buisinessDescription": "Verksemdsbeskrivelse",
  "cannotChangeFinishedProject": "Kan ikkje endre eit avslutta prosjekt.",
  "cantGetProjectTypes": "Klarte ikkje hente prosjekttypar, last inn sida på nytt og prøv igjen.",
  "causeOfProjectEnd": "Årsak til avslutning",
  "changeMainGoal": "Endre hovudmål",
  "changeMainGoalDescription": "Dykk må forlkare kvifor dykk ønskjer å endre hovudmålet til dette prosjektet. Dette blir lagt inn i klynga sin årsrapport.",
  "changeMainGoalWhy": "Kvifor har dykk endra hovudmål?",
  "changeProjectType": "Endre prosjekttype",
  "changeType": "Endre type",
  "changingMainGoal": "Endring av hovudmål",
  "changingTypeDeletesBudget": "Endring av prosjekttype vil slette all budsjettdata. Det vil kome nye kostnadstypar som må fyllast inn. Dette valet kan ikkje angrast.",
  "chooseCause": "Velg årsak",
  "chooseMultiple": "(du kan velge fleire)",
  "chooseMultipleFocusAreas": "(du kan velge flere fokusområder)",
  "chooseProgression": "Velg vidareføring",
  "clickHereToGo": "Klikk her for å gå til",
  "couldNotAddLeadToProject": "Kunne ikkje legge til lead til prosjektet.",
  "couldNotCreateCategory": "Kunne ikkje opprette ny prosjektkategori. Prøv igjen.",
  "couldNotCreateProject": "Kunne ikkje opprette prosjekt. Fiks eventuelle feil og prøv på nytt.",
  "couldNotDeleteProject": "Kunne ikkje slette prosjekt, vennlegst prøv igjen.",
  "couldNotEditActivity": "Kunne ikkje redigere aktivitet. Vennlegst prøv igjen.",
  "couldNotEndProject": "Kunne ikkje avslutte prosjekt, vennlegst prøv igjen.",
  "couldNotUpdateProject": "Kunne ikkje oppdatere prosjektet. Venlegst prøv igjen.ø",
  "createActivity": "Opprett aktivitet",
  "createProjectError": "Ein feil oppstod ved forsøk på å opprette prosjekt. Sjekk at alle felt validerar og at ny prosjektkategori ikkje har same namn som ein som allereie eksisterer.",
  "customCategories": "Eigendefinerte kategoriar",
  "customProjectCategoryName": "Namn på ny prosjektkategori",
  "deleteProject": "Slett prosjekt",
  "developmentProjects": "Utviklingsprosjekt",
  "editActivity": "Rediger aktivitet",
  "educationalOfferingsDescriptionLabel": "Prosjektet sitt innhald",
  "ended": "Avslutta",
  "endProject": "Avslutt prosjekt",
  "errorCode.Between1And5WhenEndCategoryIsCompleted": "Fornøgdheitsgrad må være mellom 1 og 5 når sluttkategori er 'fullført'",
  "errorCode.CannotSetEndReasonWhenNotTerminated": "Kan ikkje setje sluttårsak når prosjektet ikkje er avslutta",
  "errorCode.CategoryRequiredWhenNoType": "Prosjektkategori må fylles ut når type ikkje er valgt",
  "errorCode.EndSubCategoryOnlySetWhenContinued": "Underkategori for sluttårsak skal kun velgast når hovudkategori er 'vidareført'",
  "errorCode.EndSubCategoryRequiredWhenContinued": "Underkategori for sluttårsak må velgast når hovudkategori er 'vidareført'",
  "errorCode.SatisfactionRateShouldOnlyBeSetWhenCompleted": "Fornøgdheitsgrad skal kun settast når sluttkategori er 'fullført'",
  "errorCode.SourceCodeMustBeApplicationCrmOrPortal": "Prosjektkilde må vere 'Application', 'CRM' eller 'Portal'",
  "explainProjectProgression": "Forklar kva prosjektet blei vidareført til",
  "focusAreas": "Fokusområde",
  "goalDescriptionLabel": "Forventa resultat og effektmål",
  "goToProjects": "Gå til prosjekt",
  "inFinancedProjects": "prosjekt finansiert av Innovasjon Noreg",
  "inFinancedProjectsDescription": "Her ser de prosjekt finansiert av Innovasjon Noreg. Desse er henta frå søknad.",
  "justificationLabel": "Bakgrunn",
  "mainGoal": "Hovudmål",
  "missingProjectCategory": "Ved valg av prosjektkategori Anna må det skrivast inn namn på prosjektkategori.",
  "missingStartOrEndDate": "Prosjektet manglar gyldeg start eller sluttdato.",
  "mission": "Misjon",
  "newActivity": "Ny aktivitet",
  "noInFinancedProjects": "De har ingen prosjekt finansiert av Innovasjon Noreg. Prosjekt de søker om i søknaden vil visast her.",
  "noneSelected.removeParticipant": "Du må markere minst ei rad for å kunne fjerne deltakarar.",
  "noOwnProjects": "De har ingen eigen prosjekt, desse kan opprettast i portalen.",
  "numberOfEvents": "Antal eventer",
  "onlyChooseOne": "(du kan kun velge ett klyngemål)",
  "otherProjects": "Andre prosjekt",
  "ownProjects": "eigne prosjekt",
  "PEC01": "Avbrote",
  "PEC02": "Gjennomførd",
  "PEC03": "Vidareført",
  "portalProjectsDescription": "Her ser de prosjekt som er oppretta i portalen.",
  "predefinedCategories": "Predefinterte kategoriar",
  "project": "Prosjekt",
  "projectCategories": "Prosjektkategoriar",
  "projectCategoryAlreadyExists": "Ny prosjektkategori eksisterer allereie med dette namnet.",
  "projectDeleteWarning": "Er du heilt sikker på at dette prosjektet skal slettast? Alle oppretta eventer og tilhøyrande eigeninnsats vil bli sletta.",
  "projectDescription": "Prosjektbeskriving",
  "projectLeader": "Prosjektleiar",
  "projectMissingType": "Dette prosjektet manglar prosjekttype",
  "projectName": "Prosjektnamn",
  "projects": "Prosjekt",
  "projectsDescription": "Prosjekta som registrerast kan være i regi av klynga eller klyngas medlemmar. Hensikta med å registrere prosjekta som gjennomførast i klynga er å gi klyngeleiinga ei oversikt over aktiviteten som foregår i klynga.",
  "projectsPerPage": "Prosjekt per side",
  "projectType": "Prosjekttype",
  "rateProjectSuccess": "I kva grad vil du vurdere prosjektet som vellykka?",
  "registeredHours": "Registrerte timar",
  "searchMainGoal": "Søk hovudmål",
  "searchSubProject": "Søk delprosjekt",
  "seeINProjects": "For å sjå prosjekt finansiert av IN gå til",
  "seeOtherProjects": "For å sjå øvrige prosjekt kan de gå til oversikt over",
  "selectFocusAreas": "Velg fokusområde",
  "selectGoal": "Velg mål",
  "selectProject": "Velg prosjekt",
  "selectProjectCategory": "Velg prosjektkategori",
  "selectSocietalAndEnvironmentalEffects": "Velg samfunns- og miljøeffekt",
  "selectType": "Velg type",
  "societalAndEnvironmentalEffects": "Samfunns- og miljøeffekter",
  "subproject": "Delprosjekt",
  "subProjects": "Delprosjekt",
  "toAGreatExtent": "I stor grad",
  "toASmallExtent": "I lita grad",
  "trainingDescriptionLabel": "Opplæringsprosjektet sitt innhald",
  "typeChangedTo": "Type er no endra til {{newType}}",
  "uniqueParticipants": "Unike deltakarar",
  "vision": "Visjon",
  "visionAndMission": "Visjon & misjon",
  "whatWasProjectProgressedTo": "Kva blei prosjektet vidareført til?",
  "whatWasResultOfProject": "Kva blei resultatet av prosjektet?",
  "whyProjectedEnded": "Kvifor blei prosjektet avslutta?"
}
